import React from "react";
import Layout from "../../components/Layout";

const ContactContainer = () => (
  <Layout title="Contact Us">
    <div>
      <p>
        For any assistance or grievances, please reach us at
        connecttokrishnanow@gmail.com You may also reach out to our location at
        Seminar Hall, ISKCON Ghaziabad, R-11/35 Raj Nagar, Ghaziabad 201002
        (India)
      </p>
      <p>
        If you still feel your issues unaddressed, you can call/whatsapp Ravi or Khagender Sharma at (+91)9953522058.
      </p>
    </div>
  </Layout>
);

export default ContactContainer;
